/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Referral_Step2_TitleInputs */

const tr_landing_referral_step2_title = /** @type {(inputs: Landing_Referral_Step2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arkadaşınız kaydolsun`)
};

const en_landing_referral_step2_title = /** @type {(inputs: Landing_Referral_Step2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your friend signs up`)
};

const de_landing_referral_step2_title = /** @type {(inputs: Landing_Referral_Step2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihr Freund registriert sich`)
};

const ru_landing_referral_step2_title = /** @type {(inputs: Landing_Referral_Step2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Друг регистрируется`)
};

/**
* | output |
* | --- |
* | "Your friend signs up" |
*
* @param {Landing_Referral_Step2_TitleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_referral_step2_title = /** @type {((inputs?: Landing_Referral_Step2_TitleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Referral_Step2_TitleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_referral_step2_title(inputs)
	if (locale === "de") return de_landing_referral_step2_title(inputs)
	if (locale === "ru") return ru_landing_referral_step2_title(inputs)
	return tr_landing_referral_step2_title(inputs)
});